import { create } from 'zustand';

export const useCVStore = create((set) => ({
  originalText: '',
  adaptedText: '',
  jobDescription: '',
  isGenerating: false,
  error: null,
  setOriginalText: (originalText) => set({ originalText }),
  setJobDescription: (jobDescription) => set({ jobDescription }),
  setAdaptedText: (adaptedText) => set({ adaptedText }),
  setIsGenerating: (isGenerating) => set({ isGenerating }),
  setError: (error) => set({ error }),
  reset: () => set({ 
    originalText: '', 
    adaptedText: '', 
    jobDescription: '', 
    isGenerating: false, 
    error: null 
  }),
}));
